real.ajax.html = function(url, options) {
    const successFn = options.success;
    options.success = function(response) {
        if(typeof successFn === 'function') {
            successFn(response.html);
        }
    };
    return real.ajax.json(url, options);
};
